import { render, staticRenderFns } from "./add-documents-photos.vue?vue&type=template&id=70f287c8"
import script from "./add-documents-photos.vue?vue&type=script&lang=js"
export * from "./add-documents-photos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports